import { RowData } from "../../../types";
import { SCHEMA_TITLES } from "./setupsConfig";

export const BULK_IMPORT_FIELD_KEYS = {
  RECORD_IMPORT_STATUS: "record_import_status",
  RECORD_IMPORT_INFORMATION: "record_import_information",
  RECORD_VALIDATION_STATUS: "record_validation_status",
  RECORD_VALIDATION_INFORMATION: "record_validation_information",
};

const IMPORT_FIELDS = [
  {
    key: BULK_IMPORT_FIELD_KEYS.RECORD_IMPORT_STATUS,
    title: "Import Status",
  },
  {
    key: BULK_IMPORT_FIELD_KEYS.RECORD_IMPORT_INFORMATION,
    title: "Import Information",
  },
] as const;

const VALIDATION_FIELDS = [
  {
    key: BULK_IMPORT_FIELD_KEYS.RECORD_VALIDATION_STATUS,
    title: "Validation Status",
  },
  {
    key: BULK_IMPORT_FIELD_KEYS.RECORD_VALIDATION_INFORMATION,
    title: "Validation Message",
  },
];

export const CONDITIONAL_EXPORT_FIELDS = [
  {
    fields: IMPORT_FIELDS,
    condition: (row: RowData) =>
      row[BULK_IMPORT_FIELD_KEYS.RECORD_IMPORT_STATUS] != null,
  },
  {
    fields: VALIDATION_FIELDS,
    condition: (row: RowData) =>
      row[BULK_IMPORT_FIELD_KEYS.RECORD_VALIDATION_STATUS] != null,
  },
] as const;

// for setups having a single child/ correlation section that needs to be merged in a single worksheet with the parent in the export
export const PARENT_AND_CHILD_MERGED_EXPORT_SETUPS = [
  SCHEMA_TITLES.PRICING_MATRIX,
];

export const SETUP_IDENTIFIER_FIELDS: Record<string, string[]> = {
  AccountsReceivable: ["schedule_code"],
  RecurringJrnlEntries: ["journal_id", "recurring_je_reference_number"],
  PricingMatrix: ["source", "price_to_calculate", "price_break"],
};

export const COA_EXPORT_READ_ONLY_FIELDS = new Set([
  "sale_chain_reference",
  "cash_in_bank_report",
  "balance_forward_schedule",
  "detail_forward_schedule",
  "productivity_forward_schedule",
  "current_month_schedule",
  "ar_schedule_code",
  "report_group_codes",
]);

export const GROUP_ID_KEYS_TO_MAP_TO_COMPANY_ID_BY_SETUP: Map<
  string,
  string[]
> = new Map([
  [
    "RecurringJrnlEntries",
    ["target_company_group_id", "post_formula_company_group_id"],
  ],
  ["JournalTemplates", ["target_company_group_id"]],
]);
